import { Card, Text, Badge, Group, Stack, Center } from '@mantine/core';
import { IconAlbum, IconPhoto, IconLockOpen } from '@tabler/icons-react';
import { mediaUrl } from '../../api';
import { formatCents } from '../products/productDisplay';

// Public album card (AlbumPublic, contract §3.15): cover (always a public
// file), title, price, item count, and a "Purchased" badge once the caller
// owns the unlock. `onClick` navigates to /albums/{id} at the call site.
const AlbumCard = ({ album, onClick }) => (
  <Card
    shadow="sm"
    padding="md"
    radius="md"
    withBorder
    data-testid={`album-card-${album.id}`}
    style={{ cursor: onClick ? 'pointer' : 'default' }}
    onClick={onClick}
  >
    <Card.Section>
      {album.cover_path ? (
        <img
          src={mediaUrl(album.cover_path)}
          alt={album.title}
          style={{ width: '100%', height: 160, objectFit: 'cover', display: 'block' }}
        />
      ) : (
        <Center style={{ height: 160, background: 'linear-gradient(135deg, rgba(233,45,134,0.12) 0%, rgba(159,56,204,0.12) 100%)' }}>
          <IconAlbum size="2.5rem" color="var(--mantine-color-grape-4)" />
        </Center>
      )}
    </Card.Section>
    <Stack mt="sm" gap={6}>
      <Group justify="space-between" wrap="nowrap">
        <Text fw={600} lineClamp={1}>{album.title}</Text>
        {album.is_purchased && (
          <Badge color="green" variant="light" leftSection={<IconLockOpen size="0.7rem" />} style={{ flexShrink: 0 }}>
            Purchased
          </Badge>
        )}
      </Group>
      <Group justify="space-between">
        <Text size="lg" fw={700} c="pink">{formatCents(album.price_cents)}</Text>
        <Group gap={4}>
          <IconPhoto size="0.85rem" color="var(--mantine-color-gray-6)" />
          <Text size="sm" c="dimmed">
            {album.item_count} item{album.item_count === 1 ? '' : 's'}
          </Text>
        </Group>
      </Group>
    </Stack>
  </Card>
);

export default AlbumCard;
